import { CommonModal, FormDrawer, Table } from "components";
import { setOpenDrawer } from "components/elements/formDrawer/formdrawer.slice";
import { reRenderTable } from "components/elements/table/reducer/table.slice";
import { useApiMutation } from "hooks/useApi/useApiHooks";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useRoleManager } from "services/useRoleManager";
import { useAppDispatch } from "store/storeHooks";
import AcademicYearForm from "../components/AcademicYearForm";
import { useAcademicYearColumns } from "./AcademicYear.columns";

const AcademicYearTab = () => {
  const { columns, modals } = useAcademicYearColumns();
  const [wantDelete, setWantDelete] = useState<string>("");
  const [editingAcademicYear, setEditingAcademicYear] = useState<any>();
  const { t } = useTranslation();

  const formStore = useForm<any>();
  const hasAccess = useRoleManager();

  const dis = useAppDispatch();

  const resetForm = () => {
    setEditingAcademicYear(undefined);
    formStore.reset({
      startsAt: null,
      endsAt: null,
    });
  };

  const editing = !!editingAcademicYear;
  const { mutate, status } = useApiMutation(
    `/academic-year/${wantDelete}`,
    "delete",
    {}
  );

  useEffect(() => {
    if (status === "success") {
      dis(reRenderTable(true));
      setWantDelete("");
    }
  }, [status]);

  return (
    <>
      <Table
        dataUrl="/academic-year"
        columns={columns}
        title={t("general.academic_year")!}
        addButtonTitle={t("general.add_academic_year")!}
        onAddButton={
          hasAccess("_id") ? () => dis(setOpenDrawer(true)) : undefined
        }
        onEditColumn={
          hasAccess("_id")
            ? (row) => {
              dis(setOpenDrawer(true));
              setEditingAcademicYear(row);
            }
            : undefined
        }
      />

      <FormDrawer
        FORM_ID="academic-year-add"
        formItemTitle={t("general.academic_year")!}
        onClose={resetForm}
        isEditing={editing}
      >
        <AcademicYearForm
          formStore={formStore}
          editingAcademicYear={editingAcademicYear}
          resetForm={resetForm}
        />
      </FormDrawer>

      <CommonModal
        title={t("general.realy_delete")!}
        open={!!wantDelete}
        setOpen={setWantDelete}
        onSave={() => mutate({})}
        status={status}
      />

      {modals}
    </>
  );
};

export default AcademicYearTab;